import MessageBox from './src/MessageBox.js'

export function useMsgbox() {
  return MessageBox
}

export default {
  service: MessageBox
}
